import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type {
  TypeApiResponse,
  TypePostRequestCancelParams,
  TypePostRequestCancelResponse,
} from '~/types/receive.types';

type CancelParams = {
  ownerCode: string;
  params: TypePostRequestCancelParams;
};

/**
 * [입고요청관리] 입고요청 취소 API
 */
const fetchPostRequestCancel = async ({ ownerCode, params }: CancelParams) => {
  const endpoint = '/api-inbound/v1/3pl/receiving';
  const { data } = await axiosInstance.post<TypeApiResponse<TypePostRequestCancelResponse>>(
    `${endpoint}/${ownerCode}/request/cancel`,
    params
  );
  return data.data;
};

/**
 * [입고요청관리] 입고요청 취소 Mutation Hook
 */
export const usePostRequestCancelMutation = () => {
  return useMutation({
    mutationFn: fetchPostRequestCancel,
  });
};
